import { ReactNode, createContext, useContext, useEffect } from "react";
import { useLMFDataEntryActions } from "../hooks/useLMFDataEntryActions";
import { useCountdownTimer } from "@/shared/data-entries/hooks/useTimer";

const TimerContext = createContext<ReturnType<typeof useCountdownTimer>>({
  isRunning: false,
  restart: () => {},
  pause: () => {},
  resume: () => {},
  seconds: 10,
});

export const useTimerContext = () => useContext(TimerContext);

export const TimerProvider = ({
  children,
  isOldProcess = false,
}: {
  children: ReactNode;
  isOldProcess?: boolean;
}) => {
  const { refreshData } = useLMFDataEntryActions();

  const { seconds, isRunning, pause, resume, restart } = useCountdownTimer({
    initialSeconds: 10,
    onTimeUp: refreshData,
  });

  useEffect(() => {
    if (isOldProcess && isRunning) {
      pause();
    }
  }, [isOldProcess, isRunning, pause]);

  return (
    <TimerContext.Provider
      value={{ seconds, isRunning, pause, resume, restart }}
    >
      {children}
    </TimerContext.Provider>
  );
};
